export class NotFound {
    
}